import {Injectable} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {IconName} from '../enums/icon.enum';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class IconService {
  private readonly baseIconUrl = '/assets';
  private readonly icons = Object.values(IconName);
  public isInitialized$ = new BehaviorSubject<boolean>(false);

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {}

  public init() {
    const byPass = this.sanitizer.bypassSecurityTrustResourceUrl.bind(this.sanitizer);
    const addIcon = this.iconRegistry.addSvgIcon.bind(this.iconRegistry);

    this.icons.forEach((name) => {
      addIcon(name, byPass(`${this.baseIconUrl}/icons/${name}.svg`));
    });
    this.isInitialized$.next(true);
  }
}
